/* eslint-disable react/require-default-props */
import { useMemo } from 'react';
import { Control, Controller, FieldValues, Path, UnPackAsyncDefaultValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

interface Props<S extends FieldValues, T> {
  id?: string | undefined;
  name: Path<UnPackAsyncDefaultValues<S>>;
  // allowEmpty: boolean;
  options: T[];
  control: Control<S>;
  getValue: (x: T) => string | number | undefined;
  getLabel: (x: T) => string | undefined;
  isDisabled?: boolean;
  // additionalClassName?: string | undefined;
}

function SingleSelectWithFilter<S extends FieldValues, T>(
  {
    id = undefined,
    name,
    // allowEmpty,
    options,
    control,
    getValue,
    getLabel,
    isDisabled = false,
    // additionalClassName,
  }: Props<S, T>
) {

  // i18n 用。
  const {
    t,
    // i18n,
  } = useTranslation();

  const valueLabelOptions = useMemo(
    () => options.map((x) => ({ value: getValue(x), label: getLabel(x) })),
    [options, getValue, getLabel]
  );

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Select
          id={id}
          placeholder={t('選択してください')}
          options={valueLabelOptions as never}
          value={
            valueLabelOptions.find((valueLabelOption) => valueLabelOption.value === field.value)

            // valueLabelOptions.filter(
            //   (x) =>
            //     (field.value)
            //     &&
            //     // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            //     (field.value.includes(
            //       (
            //         x as {
            //           value: string | number | undefined;
            //           label: string | undefined;
            //         }
            //       ).value))
            // )
          }
          // onChange={
          //   (newValue) => {
          //     // console.log('newValue', newValue);

          //     if (typeof onChange === 'function') {
          //       if (newValue) {
          //         onChange((newValue as any).value as never);
          //       }
          //     }
          //     // else {
          //     //   void register(name).onChange(newValue as never);
          //     // }
          //   }
          //   // typeof onChange === 'function' ? onChange : register(name).onChange}
          // }
          onChange={
            (newValue) => {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-explicit-any
              // field.onChange(newValue.map((x: { value: any; }) => x.value));

              if (newValue) {
                field.onChange(newValue.value);
              }
            }
          }
          // menuPortalTarget は、メニューが他の要素の後ろに隠れないようにするため、設定したほうが良さそうです。
          // https://github.com/JedWatson/react-select/issues/3263
          menuPortalTarget={document.querySelector('body')}
          closeMenuOnSelect
          hideSelectedOptions={false}
          isDisabled={isDisabled}
          styles={{
            // モックに合わせて、スタイルを設定します。
            control: (baseStyles) => ({
              ...baseStyles,
              width: '100%',
              padding: '0',
              borderRadius: '50px',
              border: 'none',
              boxSizing: 'border-box',
              backgroundColor: '#f4f4f4',
              fontSize: '12px',
              margin: '0',
              minHeight: '25px',
            }),
            placeholder: (baseStyles) => ({
              ...baseStyles,
              paddingLeft: '8px',
            }),
            valueContainer: (baseStyles) => ({
              ...baseStyles,
              padding: '0px 0px 0px 8px',
            }),
            dropdownIndicator: (baseStyles) => ({
              ...baseStyles,
              padding: '0px 8px 0px 0px',
            }),
            clearIndicator: (baseStyles) => ({
              ...baseStyles,
              padding: '0px 8px',
            }),
            // menu が他の要素の後ろに隠れないようにするため、zIndex: 9999 を指定します。
            menuPortal: (baseStyles) => ({ ...baseStyles, zIndex: 10100, fontSize: '12px'}),
            input: (baseStyles) => ({ ...baseStyles, padding: '0px', margin: '0px' }),
          }}
        />
      )}
    />
  );
}

SingleSelectWithFilter.defaultProps = {
  id: undefined,
  // additionalClassName: undefined,
};

export default SingleSelectWithFilter;